<template>
    <div class="content limit-max">
        <Loading v-if="loading"/>
        <div class="content-wrap res" v-else>
            <div class="total-score">
                <div class="score">
                    <img src="http://guokrapp-static.guokr.com/Fu2u5J2CdmjSgRRf9f6XZA5STXhB"/>
                    <span :style="`color: ${scoreColor}`">{{result.total_score}}分</span>
                </div>
                <div class="num">
                    <p>答对{{result.correct_quiz_count}}题，共{{result.total_quiz_count}}题</p>
                    <p>赶快截图分享给好友吧</p>
                </div>
            </div>
            <div class="btns-wrap">
                <div class="action-btns">
                    <div class="cac-btn custom-btn" @click="shareMaskVisible = true">分享</div>
                    <div class="cac-btn custom-btn" @click="handleCheck">查看解析</div>
                </div>
                <div class="cac-btn custom-btn back-btn" @click="$router.go(-1)">返回</div>
            </div>
            <div class="qr-wrap">
                <img :src="qrcode"/>
                <p>
                    <img src="http://guokrapp-static.guokr.com/FnsMthIgcOkNeavK1kylE3l1VSdk"/>
                    立即扫码参加
                    <img src="http://guokrapp-static.guokr.com/FnsMthIgcOkNeavK1kylE3l1VSdk"/>
                </p>
                <p>
                    果壳少年科学素养测试
                </p>
            </div>
            <div class="share-mask limit-max" v-if="shareMaskVisible" @click="shareMaskVisible = false">
                <img src="http://guokrapp-static.guokr.com/FtigJuVRCz9YwPhszxrMXLsu_l9V"/>
            </div>
            <img src="http://guokrapp-static.guokr.com/FmG51Y2z5yeQqJd-kW-WuF-ZoYpE" alt="" class="p2"/>
        </div>
    </div>
</template>

<script>
import { Loading } from 'vant';
import { cacQuizResultResultIdGet } from '@/apis/cac'

export default {
    name: 'Res',
    components: {
        Loading
    },
    data () {
        return {
            loading: true,
            shareMaskVisible: false,
            results: [],
            qrcode: ''
        }
    },
    computed: {
        result () {
            let result = {
                total_score: 0,
                correct_quiz_count: 0,
                total_quiz_count: this.results.length,
            }
            this.results.forEach((item) => {
                if (item.is_right) {
                    result.correct_quiz_count++
                    result.total_score += item.gotten_score
                }
            })
            return result
        },
        scoreColor () {
            const score = this.result.total_score
            if (score <= 100 && score >= 80) {
                return '#F85F48'
            } else if (score < 80 && score >= 50) {
                return '#0084C4'
            } else {
                return '#028769'
            }
        }
    },
    mounted () {
        this.getInfo()
        this.getQrcode()
    },
    methods: {
        async getInfo() {
            try {
                const {
                    body
                } = await cacQuizResultResultIdGet({
                    params: {
                        resultId: this.$route.params.result_id
                    }
                })

                this.results = body
                this.loading = false
            } catch (error) {
                this.location.replace('/cac')
            }
        },
        async getQrcode () {
            this.qrcode = (await this.GLOBAL.getConfig('cacQrcodeImg'))?.cacQrcodeImg
        },
        handleCheck() {
            this.location.push(`/cac/analysis/${this.$route.params.result_id}`)
        }
    }
};
</script>
<style lang="less" scoped>
.content {
    &.limit-max {
        margin: auto;
        @media screen and (min-width: 750px) {
            .res {
                .btns-wrap {
                    margin-top: 10%;
                    .cac-btn {
                        width: 20rem;
                        height: 8rem;
                    }
                }
            }
        }
    }
    .res {
        &.content-wrap {
            background-image: url(http://guokrapp-static.guokr.com/Fudvr7yllh2kcXonhok25xlKb3D6);
            background-position: bottom center;
        }
        .total-score {
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-top: 20px solid #fff;
            border-bottom: 20px solid #fff;
            background-image: url(http://guokrapp-static.guokr.com/FtuelevSUWtyYjcUjUqtSWMDZHAb);
            position: relative;
            width: 85%;
            height: 30%;
            margin: 30px auto 0;
            background-size: 100% 100%;
            min-height: 145px;
            &::before {
                content: ' ';
                display: block;
                width: 18px;
                height: 18px;
                background-image: url(http://guokrapp-static.guokr.com/FkKiDokFsXB5PcSpy5tiQRH_ym6Z);
                background-size: 100% 100%;
                position: absolute;
                left: 5px;
                top: -19px;
            }
            &::after {
                content: ' ';
                width: 50px;
                height: 40px;
                background-image: url(http://guokrapp-static.guokr.com/Fo1c6%JksRfLhdOU01byTrVnz_b);
                background-size: 100% 100%;
                position: absolute;
                right: 5px;
                bottom: 5px;
            }
            .score {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 3%;
                img {
                    height: 40px;
                }
                span {
                    color: #0084C4;
                    font-size: 40px;
                    line-height: 56px;
                    margin-left: 20px;
                }
            }
            .num {
                font-size: 17px;
                color: #000;
                line-height: 1.5;
                text-align: center;
            }
        }
        // p {
        //     margin-top: 4%;
        //     color: #fff;
        //     font-size: 16px;
        //     text-align: center;
        // }
        .btns-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 3%;
            flex-wrap: wrap;
            flex-direction: column;
            .btn {
                &:first-child{
                    margin-right:3rem;
                }
            }
            .action-btns {
                display: flex;
                flex-direction: row;
            }
            .custom-btn {
                width: 13rem;
                height: 5rem;
                background-image: url(http://guokrapp-static.guokr.com/FjekSFAdnlWpwhJFiR-uG5hO5EU-);
                background-size: 100% 100%;
                line-height: 15%;
                text-align: center;
                font-size: 17px;
                color: #0084C4;
                font-size: 20px;
                &:first-child{
                    margin-right:3rem;
                }
                &.back-btn {
                    margin-top: 10px;
                    background-image: url(http://guokrapp-static.guokr.com/Fj4w8vMfw3ggmremAVTR486jEWHQ);
                    width: 25%;
                    color: #fff;
                }
            }
        }
        .qr-wrap{
            display: flex;
            justify-content: flex-end;
            flex: 1;
            flex-direction: column;
            align-items: center;
            margin-bottom: 40px;
            img{
                width: 27%;
                margin-top: 20px;
                margin-bottom: 10px;
            }
            p{
                margin:0;
                text-align: center;
                color: #fff;
                font-size: 12px;
                line-height: 18px;
                min-height: 15px;
                display: flex;
                align-items: center;
                img {
                    width: 8px;
                    height: 10px;
                    margin: 0 2px;
                }
            }
        }
        .share-mask {
            position: fixed;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.7);
            display: flex;
            justify-content: flex-end;
            align-items: flex-start;
            z-index: 888;
            img {
                width: 50%;
            }
        }
        
        .p2 {
            position: absolute;
            bottom: 0;
            left: 4%;
            width: 15%;
        }
    }
}
</style>
